module.exports = __webpack_public_path__ + "static/media/close-black.9ca5a0df.svg";